import Page2 from '../pages/Page2'
import HomePage from '../pages/HomePage';
import SciencePage from '../pages/SciencePage';
import GameSettingsPage from '../pages/GameSettingsPage';
import TitlePage from '../pages/TitlePage';
import StaticScreenPage from '../pages/StaticScreenPage';
import LevelBuilderPage from '../pages/LevelBuilderPage';
import CreditsPage from '../pages/CreditsPage';
import LevelTilesPage from '../pages/LevelTilesPage';
import MusicPage from '../pages/MusicPage';
import GraphicsPage from '../pages/GraphicsPage';
import SharePage from '../pages/SharePage';
import GamePlayPage from '../pages/GamePlayPage';
import StaticScreenEditorPage from '../pages/StaticScreenEditorPage';
import HudPage from '../pages/HudPage';
import SfxPage from '../pages/SfxPage';
import CustomCodePage from '../pages/CustomCodePage';
import AboutPage from '../pages/AboutPage';
import ShowcasePage from '../pages/ShowcasePage';
import ContactPage from '../pages/ContactPage';

function linkStartsWith(link, pathname) {
    return pathname.startsWith(link?.href);
}

export default [
    {groupName: 'default', root: '/', title: null, elements: [
        {name: 'Home', icon: 'home', href: '/home', element: <HomePage />},
        {name: 'Browse', icon: 'grid', href: '/games/browse', enabled: false, element: <Page2 />},
    ]},
    {divider: true, filter: (user, game) => game}, 
    {groupName: 'gameDetails2', title: 'Game Settings', root: '/builder', filter: (user, game) => game, elements: [
        {name: 'Title Screen', icon: 'title', href: '/builder/title', element: <TitlePage />},
        {name: 'Level Designer', icon: 'design', href: '/builder/level', element: <LevelBuilderPage />},
        {name: 'Credits', icon: 'text', href: '/builder/credits', element: <CreditsPage />},
        {name: 'Other Screens', icon: 'screen', href: '/builder/static-screens', element: <StaticScreenPage />, isActive: linkStartsWith}
    ]},
    {divider: true, filter: (user, game) => game},
    {groupName: 'gameDetails3', title: 'Advanced', root: '/builder', filter: (user, game) => game, elements: [
        {name: 'Graphics', icon: 'art', href: '/builder/graphics', element: <GraphicsPage />},
        {name: 'Map Tiles', icon: 'tile', href: '/builder/tiles', element: <LevelTilesPage />},
        {name: 'Music', icon: 'music', href: '/builder/music', element: <MusicPage />},
        {name: 'Sound Effects', icon: 'sound', href: '/builder/sfx', element: <SfxPage />},
        {name: 'HUD', icon: 'fish', href: '/builder/hud', element: <HudPage />},
        {name: 'Other Settings', icon: 'config', href: '/builder/config', element: <GameSettingsPage />},
        {name: 'Custom Code', icon: 'code', href: '/builder/code', element: <CustomCodePage />}
    ]},
    {divider: true, filter: (user, game) => game},
    {groupName: 'gameTitle', title: '{%gameTitle%}', root: '/builder', filter: (user, game) => game, elements: [
        {name: 'Play Current', isPlayButton: true},
        {name: 'Share', icon: 'send', href: '/builder/share', visible: false,  element: <SharePage />},
    ]},

    {groupName: 'community', title: 'Community', visible: false, elements: [
        {name: 'About', icon: 'screen', href: '/about', element: <AboutPage />},
        {name: 'Contact', icon: 'phone', href: '/contact', element: <ContactPage />},
        {name: 'Discord', icon: 'discord', href: 'https://discord.gg/cEtyYyZhCc', external: true},
        {name: "Issue Tracker", icon: "card", href: "https://github.com/igwgames/nes-puzzle-maker-rom/issues", external: true},
        {name: 'Showcase', icon: 'screen', href: '/showcase', element: <ShowcasePage />},
    ]},
    {groupName: 'other', root: '/', title: null, visible: false, elements: [
        // For pages that shouldn't show in the ui, and shouldn't have an item selected. 
        // (If an item should be selected, throw it in the section above and mark it as visible: false)
        {name: 'Science', icon: 'science', href: '/science', element: <SciencePage />},
        {name: 'Play Game', icon: 'game', href: '/play/:gameId/:unused', element: <GamePlayPage />},
        {name: 'Edit Screen', icon: 'screen', href: '/builder/static-screens/:screenId', element: <StaticScreenEditorPage />},
    ]}
];